import { create } from 'zustand';

interface FullScreenDialogStoreState {
    isOpen: boolean;
    title: string;
    planData: any;
}

interface FullScreenDialogStoreAction {
    action: {
        open: () => void;
        close: () => void;
        setTitle: (title: string) => void;
        setPlanData: (planData: any) => void;
    };
}

const defaultState: FullScreenDialogStoreState = {
    isOpen: false,
    title: '',
    planData: null,
};

const useFullScreenDialogStore = create<FullScreenDialogStoreState & FullScreenDialogStoreAction>()((set) => ({
    ...defaultState,
    action: {
        open: () => set(() => ({ isOpen: true })),
        close: () => set(() => ({ isOpen: false })),
        setTitle: (title) => set(() => ({ title })),
        setPlanData: (planData) => set(() => ({ planData })),
    },
}));

export const useFullScreenDialogStoreIsOpen = () => useFullScreenDialogStore((state) => state.isOpen);
export const useFullScreenDialogStoreTitle = () => useFullScreenDialogStore((state) => state.title);
export const useFullScreenDialogStoreAction = () => useFullScreenDialogStore((state) => state.action);

// 메인 스토어 훅도 내보내기
export { useFullScreenDialogStore };
